interface TestimonialCardProps {
  quote: string;
  author: string;
  role: string;
  company: string;
  metric?: {
    value: string;
    label: string;
  };
}

const TestimonialCard = ({
  quote,
  author,
  role,
  company,
  metric,
}: TestimonialCardProps) => {
  return (
    <article 
      className="p-8 rounded-2xl border border-border bg-background transition-all duration-300 hover:shadow-lg hover:-translate-y-1 hover:border-foreground/10"
      itemScope
      itemType="https://schema.org/Review"
    >
      {metric && (
        <div className="mb-6 pb-6 border-b border-border">
          <p className="text-4xl font-semibold text-primary mb-1">{metric.value}</p>
          <p className="text-sm text-muted-foreground">{metric.label}</p>
        </div>
      )}
      <blockquote className="text-foreground mb-6 leading-relaxed" itemProp="reviewBody">
        "{quote}"
      </blockquote>
      <footer className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-muted flex items-center justify-center">
          <span className="text-sm font-medium text-foreground">
            {author.split(" ").map(n => n[0]).join("")}
          </span>
        </div>
        <div>
          <p className="font-medium text-foreground" itemProp="author">{author}</p>
          <p className="text-sm text-muted-foreground">
            {role}, <span itemProp="itemReviewed">{company}</span>
          </p>
        </div>
      </footer>
    </article>
  );
};

export default TestimonialCard;
